const YouAreMySunshine = [
	'[Chorus]',
	'You are my sunshine',
	'My only sunshine',
	'You make me happy',
	'When skys are grey',
	"You'll never know, dear",
	'How much i love you',
	'Please dont take my sunshine away',
	'',
	'[Verse 1]',
	'The other night dear,',
	'While i lay sleeping',
	'I dreamed i held you',
	'Here in my arms',
	'When i awoke, dear',
	'I was mistaken',
	'And i held my head and i cried',
	'',
	'[Chorus]',
	'You are my sunshine',
	'My only sunshine',
	'You make me happy',
	'When skys are grey',
	"You'll never know, dear",
	'How much i love you',
	'Please dont take my sunshine away',
	'',
	'[Verse 2]',
	"I'll always love you",
	'And make you happy',
	'If you will only',
	'Say the same',
	'But if you leave me',
	'To love another',
	"You'll regret it all, someday",
	'',
	'[Chorus]',
	'You are my sunshine',
	'My only sunshine',
	'You make me happy',
	'When skys are grey',
	"You'll never know, dear",
	'How much i love you',
	'Please dont take my sunshine away',
	'Please dont take my sunshine away',
];

export default YouAreMySunshine;
